import { OrderResponseDto } from '@planning/app/api'
import { orderService } from '@planning/services'
import { Event, IEvent, IQueryHandler, IQueryMessage } from '@tom-ui/utils'

export class GetOrdersByIdsQuery implements IQueryMessage {
  static type = 'GetOrdersByIdsQuery'
  type = GetOrdersByIdsQuery.type

  constructor(public ids: number[]) {}

  getKey = () => {
    return JSON.stringify(this)
  }
}

export const getOrdersByIdsQueryHandler: IQueryHandler<
  GetOrdersByIdsQuery,
  IEvent<OrderResponseDto[]>
> = async query => {
  const data = await orderService.getByIds(query.ids)

  return new Event(GetOrdersByIdsQuery.type, data)
}
